import { render, staticRenderFns } from "./ChooseBox.vue?vue&type=template&id=23148c2e&scoped=true"
import script from "./ChooseBox.vue?vue&type=script&lang=js"
export * from "./ChooseBox.vue?vue&type=script&lang=js"
import style0 from "./ChooseBox.vue?vue&type=style&index=0&id=23148c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23148c2e",
  null
  
)

export default component.exports